import { render, staticRenderFns } from "./DashboardPessoaJuridica.vue?vue&type=template&id=24372a06&"
import script from "./DashboardPessoaJuridica.vue?vue&type=script&lang=js&"
export * from "./DashboardPessoaJuridica.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPessoaJuridica.vue?vue&type=style&index=0&id=24372a06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports